import { create } from "zustand";
import { DEFAULT_AUTO_SIZE_VDROP_TARGET, type AutoSizeVdropTarget } from "./auto-size-vdrop-default";
export { DEFAULT_AUTO_SIZE_VDROP_TARGET, type AutoSizeVdropTarget } from "./auto-size-vdrop-default";

const KEY = "twelve-volt:auto-size-vdrop-target";

function readPref(): AutoSizeVdropTarget {
  try {
    const v = localStorage.getItem(KEY);
    if (v === "5") return 5;
    if (v === "3") return 3;
  } catch {}
  return DEFAULT_AUTO_SIZE_VDROP_TARGET;
}

interface AutoSizeVdropTargetState {
  target: AutoSizeVdropTarget;
  setTarget(t: AutoSizeVdropTarget): void;
}

export const useAutoSizeVdropTarget = create<AutoSizeVdropTargetState>((set) => ({
  target: readPref(),
  setTarget: (t) => {
    try {
      localStorage.setItem(KEY, String(t));
    } catch {}
    set({ target: t });
  },
}));
